"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthsOptions = exports.messages = void 0;
exports.messages = {
    fr: {
        day: 'Jour',
        year: 'Année',
        monthPlaceholder: 'Mois',
        months: [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre',
        ],
    },
    en: {
        day: 'Day',
        year: 'Year',
        monthPlaceholder: 'Month',
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
    },
};
/**
 * @ignore
 */
const monthsOptions = (locale) => {
    const { months } = exports.messages[locale];
    const options = months.map((month, index) => {
        const value = `${index + 1}`.padStart(2, '0');
        return {
            label: month,
            value,
        };
    });
    return options;
};
exports.monthsOptions = monthsOptions;
//# sourceMappingURL=utils.js.map